import { Injectable } from '@angular/core';

/**
 * Custom event service to dispatch an event
 */
@Injectable({
  providedIn: 'root',
})
export class CustomEventService {
  /**
   * Creates an instance of custom event service.
   */
  constructor() {}

  /**
   * Dispatch event
   * @param name Name of the event
   * @param body Event detail should be provided in body
   */
  dispatchEvent(name: string, body: any) {
    document.dispatchEvent(new CustomEvent(name, { detail: body }));
  }

  /**
   * Subscribes event
   * @param name Name of event
   * @param handler Event handler
   */
  subscribeEvent(name: string, handler: any) {
    document.addEventListener(name, handler);
  }

  /**
   * Unsubscribe event
   * @param name Event name
   * @param handlerReference Event handler reference
   */
  unsubscribeEvent(name: string, handlerReference: any) {
    document.removeEventListener(name, handlerReference);
  }
}
